query WhoAmI {
  me {
    id
    firstName
    lastName
    email
    groups
    isSuperuser
    isCanadaOnlyPca
    profileImage {
      profilePictureUrl
    }
  }
}
